package com.eladfinish.bible.contest.features.review

import org.koin.dsl.module

actual val reviewPlatformModule = module {
    single<InAppReviewLauncher> { UnsupportedInAppReviewLauncher }
}
